/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsPrizeTypeSchema } from "./prizeTypeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsPrizeDistributionRowDtoSchema = z.object({
  placeFrom: z.optional(z.int()),
  placeTo: z.optional(z.int()),
  get prizeType() {
    return goodLuckCoreDTOsPrizeTypeSchema.optional();
  },
  sharePercent: z.number().nullish(),
  quantity: z.int().nullish(),
  description: z.string().max(500).nullish(),
});
